/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DistrictCreate } from '../models/DistrictCreate';
import type { DistrictDetails } from '../models/DistrictDetails';
import type { DistrictMinimalDetails } from '../models/DistrictMinimalDetails';
import type { DistrictUpdate } from '../models/DistrictUpdate';
import type { IVRDistrict } from '../models/IVRDistrict';
import type { PagedItems } from '../models/PagedItems';
import type { PagingQuery } from '../models/PagingQuery';
import { request as __request } from '../core/request';

export class DistrictsVService {

    /**
     * @param requestBody
     * @returns PagedItems OK
     * @throws ApiError
     */
    public static async districtsVGetAll(
        requestBody?: PagingQuery,
    ): Promise<PagedItems> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/districts/get`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns DistrictDetails OK
     * @throws ApiError
     */
    public static async districtsVGetExport(
        requestBody?: PagingQuery,
    ): Promise<DistrictDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/districts/export`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param districtId
     * @param requestBody
     * @returns DistrictDetails OK
     * @throws ApiError
     */
    public static async districtsVUpdateDistrict(
        districtId: string,
        requestBody?: DistrictUpdate,
    ): Promise<DistrictDetails> {
        const result = await __request({
            method: 'PATCH',
            path: `/api/v2/districts/${districtId}`,
            body: requestBody,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param districtId
     * @returns DistrictDetails OK
     * @throws ApiError
     */
    public static async districtsVGetById(
        districtId: string,
    ): Promise<DistrictDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/districts/${districtId}`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorId
     * @param onlyRocketpack
     * @returns DistrictMinimalDetails OK
     * @throws ApiError
     */
    public static async districtsVGetAllAnon(
        operatorId: string,
        onlyRocketpack?: boolean,
    ): Promise<Array<DistrictMinimalDetails>> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/districts/${operatorId}/all`,
            query: {
                'onlyRocketpack': onlyRocketpack,
            },
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @param requestBody
     * @returns DistrictDetails Created
     * @throws ApiError
     */
    public static async districtsVCreate(
        requestBody?: DistrictCreate,
    ): Promise<DistrictDetails> {
        const result = await __request({
            method: 'POST',
            path: `/api/v2/districts`,
            body: requestBody,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
            },
        });
        return result.body;
    }

    /**
     * @param operatorCode
     * @param districtCode
     * @returns DistrictDetails OK
     * @throws ApiError
     */
    public static async districtsVGetByCodes(
        operatorCode?: string,
        districtCode?: number,
    ): Promise<DistrictDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/districts`,
            query: {
                'operatorCode': operatorCode,
                'districtCode': districtCode,
            },
        });
        return result.body;
    }

    /**
     * @param ueid
     * @returns IVRDistrict OK
     * @throws ApiError
     */
    public static async districtsVGetByIvrUeid(
        ueid: string,
    ): Promise<IVRDistrict> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/districts/ivr/${ueid}`,
            errors: {
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
            },
        });
        return result.body;
    }

    /**
     * @returns DistrictDetails OK
     * @throws ApiError
     */
    public static async districtsVGetInfoExport(): Promise<DistrictDetails> {
        const result = await __request({
            method: 'GET',
            path: `/api/v2/districts/info`,
        });
        return result.body;
    }

}